import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SportService } from '@app/core/services';
import { CommonService } from '@app/core/services/common.service';
import { ReplaySubject, takeUntil } from 'rxjs';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
  selector: 'app-additional-content',
  templateUrl: './additional-content.component.html',
  styleUrls: ['./additional-content.component.scss']
})
export class AdditionalContentComponent implements OnInit {
  protected destroyed$ = new ReplaySubject<boolean>(1);
  data:string = '';
  /**
   *
   * @param {CommonService} _common
   * @param {SportService} _sport
   */
  constructor(
    public _common: CommonService,
    private _sport: SportService,
    private _activated: ActivatedRoute
  ) {}

  async ngOnInit() {
    this._activated.data.pipe(takeUntil(this.destroyed$)).subscribe((data) => {
      this.data = '';
      let sport = data['sport'] || this._sport.defaultSport;
      let sportsData = this._common.configuration.getValue()?.sports;
      sportsData = sportsData.find((singleSport:any)=>singleSport.slug?.toLowerCase() === sport.toLowerCase());
      if(sportsData?.description){
        this.data = sportsData?.description;
        this._common.setTitle(sportsData?.home_meta_title);
        this._common.updateMeta('description',sportsData?.home_meta_description);
        this._common.updateMeta('twitter:description',sportsData?.home_meta_description);
        this._common.updatePropertyMeta('og:description',sportsData?.home_meta_description);
      }
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

}
